<script setup lang="ts">
import type { MediaFragment, PressThumbFragment } from '#graphql-operations'

interface CardPressProps {
  data: PressThumbFragment
}

const props = defineProps<CardPressProps>()

const thumbMedia = computed(() => props.data.thumbMedia as MediaFragment[])
const customLink = computed(() => parseCraftLink(props.data.customLink))
</script>

<template>
  <article class="cardPress h-full">
    <CraftLink :link="data.customLink" class="group-buttonLink flex flex-col h-full space-y-4">
      <figure class="space-y-4">
        <div class="rounded-2 bg-ivory aspect-1.45 of-hidden">
          <CraftMedia
            v-for="media in thumbMedia"
            :key="media.id"
            :media
            :img-props="{ alt: data.title }"
          />
        </div>

        <figcaption class="space-y-1.5">
          <Text :text="data.date" class="typo-sans-1" />
          <Text as="h3" :text="data.title" class="typo-sans-1 uppercase" />
        </figcaption>
      </figure>

      <div
        v-if="customLink"
        class="mt-auto space-y-4"
      >
        <Text :html="data.description" class="typo-serif-1 line-clamp-4" />
        <ButtonLink
          as="span"
          :link="data.customLink"
          :title="$t('read_more')"
        />
      </div>
    </CraftLink>
  </article>
</template>
